module.exports = __webpack_public_path__ + "img/image3.8bff3398.jpg";